module.exports = __webpack_public_path__ + "images/avatar-joeyyin-4f67f1b38404624aa9f5bf7ffaf5067b.png";